// extracted by mini-css-extract-plugin
export var modal = "Modal-module--modal--h6Y06";
export var modalContent = "Modal-module--modalContent--I7Iv7";
export var overlay = "Modal-module--overlay--0BXXk";